import { createRouter } from '@tanstack/react-router';

import { queryClient } from '../queryClient';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
  routeTree,
  context: {
    queryClient,
  },
  defaultPreload: 'intent',
  defaultPreloadDelay: 50,
  defaultPreloadStaleTime: 0,
  notFoundMode: 'root',
  scrollRestoration: true,
  // Disable the global catch boundary to make sure error is catched by sentry error boundary
  disableGlobalCatchBoundary: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
